import { useEffect } from "react";
import GetUserBasicInfoDocument from "src/api/graphql/__generated__/documents/GetUserBasicInfoDocument";
import useRevalidatedQuery from "src/hooks/useRevalidatedQuery";
import { Link } from "src/swsh-native";
import { ProfileProps } from "./types";

const Profile = ({
	userId,
	children,
	renderContent,
	style,
	testID,
	onProfileLoaded,
	onProfileUnavailable,
}: ProfileProps) => {
	const { data, loading } = useRevalidatedQuery(GetUserBasicInfoDocument, {
		variables: {
			input: {
				userId,
			},
		},
	});
	const profile = data?.getUserBasicInfo;
	useEffect(() => {
		if (profile?.userId) {
			onProfileLoaded?.({
				userId: profile.userId,
				firstName: profile?.firstName ?? null,
				lastName: profile?.lastName ?? null,
				instagramUsername: profile?.instagramUsername ?? null,
				snapchatUsername: profile?.snapchatUsername ?? null,
				isVerified: profile?.isVerified ?? false,
			});
		}
	}, [onProfileLoaded, profile]);
	useEffect(() => {
		if (!loading && !profile?.userId) {
			onProfileUnavailable?.({ userId });
		}
	}, [loading, onProfileUnavailable, profile?.userId, userId]);

	return (
		<Link href={`/user_/${userId}`} style={style} testID={testID}>
			{renderContent && profile?.userId
				? renderContent({
						userId: profile.userId,
						firstName: profile?.firstName ?? null,
						lastName: profile?.lastName ?? null,
						instagramUsername: profile?.instagramUsername ?? null,
						snapchatUsername: profile?.snapchatUsername ?? null,
						isVerified: profile?.isVerified ?? false,
					})
				: children}
		</Link>
	);
};
export default Profile;
